import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import useRequest from '@swf/core/hooks/useRequest';
import type {
  GetClubTableStructuresResponse,
  HgClubTableStructures
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

import type { FormValues } from '../utils/common';
import { getInitialValues } from '../utils/common';

interface State {
  error?: string | null;
  message?: string | null;
  data: HgClubTableStructures;
  initialValues?: FormValues;
}

const initialResponse: State = { error: null, message: null, data: {}, initialValues: undefined };

const useGetClubTableStructures = () => {
  const [response, setResponse] = useState(initialResponse);
  const [loading, setLoading] = useState(true);
  const request = useRequest();
  const {
    state: { clubId }
  } = useLocation<{ clubId: string | undefined }>();

  useEffect(() => {
    request({
      service: 'homeGames.getClubTableStructuresRequest',
      body: { clubId }
    }).subscribe({
      next: ({ body }: { body: GetClubTableStructuresResponse }) => {
        const { error, data, message } = handleServerResponse<
          GetClubTableStructuresResponse,
          HgClubTableStructures
        >({
          response: body,
          accessor: 'tableStructures'
        });
        const tableParams = data?.tableParams;

        setResponse({
          error,
          data: {
            ...data,
            tableParams
          },
          message,
          initialValues: getInitialValues(tableParams)
        });
        setLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { response, loading };
};

export default useGetClubTableStructures;
